import { Box, Container, Skeleton, Text } from "@chakra-ui/react";
import { ReactNode } from "react";
import { ActionModal } from "../../Controls/Modal";
import { useStore } from "../../../Store";
import { useNavigate } from "react-router-dom";

interface ManagementPortalContainerProps {
  children: ReactNode;
}

export default function ManagementPortalContainer(
  props: ManagementPortalContainerProps
) {
  const { loading, showPopupError, popupErrorMessage } = useStore();

  const navigate = useNavigate();

  return (
    <Container maxW={"500px"} px={0} mb={5}>
      <ActionModal
        data-testid="modalError"
        show={showPopupError}
        title="Error"
        handleAction={() => navigate("/DashboardLanding")}
        confirmButtonText="Ok"
        handleOnClose={() => {
          // keep modal open
        }}
      >
        <Text>{popupErrorMessage}</Text>
      </ActionModal>
      {Boolean(loading) ? (
        <>
          <Box py={10}>
            <Skeleton height="50px" mb={4} />
            <Skeleton height="20px" mb={2} mr={10} />
            <Skeleton height="20px" mr={16} />
          </Box>
        </>
      ) : (
        <>{props.children}</>
      )}
    </Container>
  );
}
